let promoGrid;
function vuePromoGrid() {
    promoGrid = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const collections = Vue.ref(false);

            const promoTypes = Vue.computed(() => {
                if (!collections.value) return [];
                const seen = new Set();
                const types = [];
                collections.value.forEach((collection) => {
                    const type = collection?.node?.promoType?.value || 'Other';
                    if (!seen.has(type)) {
                        seen.add(type);
                        types.push(type);
                    }
                });
                return types;
            });

            const checkedTypes = Vue.ref([]);

            const isTypeChecked = (type) => checkedTypes.value.includes(type);

            const toggleTypeFilter = (type) => {
                const idx = checkedTypes.value.indexOf(type);
                if (idx > -1) {
                    checkedTypes.value.splice(idx, 1);
                } else {
                    checkedTypes.value.push(type);
                }
            };

            const visibleCollections = Vue.computed(() => {
                if (!collections.value) return false;
                if (!checkedTypes.value.length) return collections.value;
                return collections.value.filter((collection) => checkedTypes.value.includes(collection?.node?.promoType?.value || 'Other'));
            });

            const retrieveCollections = async () => {
                const globalTools = window.globalTools();
                const queryString = `{
	                collections(first:100, query: "collection_type:custom", sortKey:UPDATED_AT, reverse:true) {
		                edges {
            			    node {
				                title
				                handle
				                promoType:metafield(namespace:"promotion",key:"type") { value }
				                promoMobileImage:metafield(namespace:"promotion",key:"mobile_image") {
					                reference {
						                ... on MediaImage{
							                image {
								                url
    							            }
	    					            }
		    			            }
			    	            }
				                promoSortOrder:metafield(namespace:"promotion",key:"sortOrder") { value }
    			            }
	    	            }
	                }
                }`
                try {
                    const collectionArray = await globalTools.genericQuery(queryString);
                    const filteredCollections = collectionArray.data?.collections?.edges?.filter(edge => edge?.node?.promoType?.value && edge?.node?.promoMobileImage?.reference?.image?.url);
                    const sortedCollections = filteredCollections.sort((a, b) => (Number(a?.node?.promoSortOrder?.value) || 999) - (Number(b?.node?.promoSortOrder?.value) || 999));
                    collections.value = sortedCollections;
                } catch (error) {
                    console.error(`Error fetching promotions: ${error}`)
                }
            }

            Vue.onMounted(() => {
                retrieveCollections();
            });

            return {
                collections,
                promoTypes,
                visibleCollections,
                isTypeChecked,
                toggleTypeFilter
            }
        },
    });
    promoGrid.use(window.VueAppGlobals.pinia);
    promoGrid.mount('#promoPane');
}

if (window.Vue && window.Pinia) {
    vuePromoGrid();
} else {
    window.addEventListener('vue-ready', vuePromoGrid);
}